(function ($, Cobalt, undefined) {
    Cobalt.DateTimeField = {
        initialize: function () {
            var dateTimeFields = $(".date-time.time");
            if (dateTimeFields.length > 0) {
                var timePresets = timePresets || new Array(
                        { timeValue: "00:00", timeKey: "12:00 AM" },
                        { timeValue: "00:30", timeKey: "12:30 AM" },
                        { timeValue: "01:00", timeKey: "1:00 AM" },
                        { timeValue: "01:30", timeKey: "1:30 AM" },
                        { timeValue: "02:00", timeKey: "2:00 AM" },
                        { timeValue: "02:30", timeKey: "2:30 AM" },
                        { timeValue: "03:00", timeKey: "3:00 AM" },
                        { timeValue: "03:30", timeKey: "3:30 AM" },
                        { timeValue: "04:00", timeKey: "4:00 AM" },
                        { timeValue: "04:30", timeKey: "4:30 AM" },
                        { timeValue: "05:00", timeKey: "5:00 AM" },
                        { timeValue: "05:30", timeKey: "5:30 AM" },
                        { timeValue: "06:00", timeKey: "6:00 AM" },
                        { timeValue: "06:30", timeKey: "6:30 AM" },
                        { timeValue: "07:00", timeKey: "7:00 AM" },
                        { timeValue: "07:30", timeKey: "7:30 AM" },
                        { timeValue: "08:00", timeKey: "8:00 AM" },
                        { timeValue: "08:30", timeKey: "8:30 AM" },
                        { timeValue: "09:00", timeKey: "9:00 AM" },
                        { timeValue: "09:30", timeKey: "9:30 AM" },
                        { timeValue: "10:00", timeKey: "10:00 AM" },
                        { timeValue: "10:30", timeKey: "10:30 AM" },
                        { timeValue: "11:00", timeKey: "11:00 AM" },
                        { timeValue: "11:30", timeKey: "11:30 AM" },
                        { timeValue: "12:00", timeKey: "12:00 PM" },
                        { timeValue: "12:30", timeKey: "12:30 PM" },
                        { timeValue: "13:00", timeKey: "1:00 PM" },
                        { timeValue: "13:30", timeKey: "1:30 PM" },
                        { timeValue: "14:00", timeKey: "2:00 PM" },
                        { timeValue: "14:30", timeKey: "2:30 PM" },
                        { timeValue: "15:00", timeKey: "3:00 PM" },
                        { timeValue: "15:30", timeKey: "3:30 PM" },
                        { timeValue: "16:00", timeKey: "4:00 PM" },
                        { timeValue: "16:30", timeKey: "4:30 PM" },
                        { timeValue: "17:00", timeKey: "5:00 PM" },
                        { timeValue: "17:30", timeKey: "5:30 PM" },
                        { timeValue: "18:00", timeKey: "6:00 PM" },
                        { timeValue: "18:30", timeKey: "6:30 PM" },
                        { timeValue: "19:00", timeKey: "7:00 PM" },
                        { timeValue: "19:30", timeKey: "7:30 PM" },
                        { timeValue: "20:00", timeKey: "8:00 PM" },
                        { timeValue: "20:30", timeKey: "8:30 PM" },
                        { timeValue: "21:00", timeKey: "9:00 PM" },
                        { timeValue: "21:30", timeKey: "9:30 PM" },
                        { timeValue: "22:00", timeKey: "10:00 PM" },
                        { timeValue: "22:30", timeKey: "10:30 PM" },
                        { timeValue: "23:00", timeKey: "11:00 PM" },
                        { timeValue: "23:30", timeKey: "11:30 PM" }
                    );

                $(dateTimeFields).on("focus", function () {
                    var timeField = $(this);
                    var timeSelector = $(".time-selector");

                    if (timeSelector.length <= 0) {
                        timeSelector = $("<div>");
                        timeSelector.addClass("time-selector").css("top", timeField.position().top + timeField.outerHeight(true) + 'px').css('left', timeField.position().left).css('position', 'absolute');
                        var timeSelectorList = $("<ul>");
                        for (var i = 0; i < timePresets.length; i++) {
                            var timeSelectorRow = $("<li>");
                            timeSelectorRow.addClass("row");
                            timeSelectorRow.addClass("time-value-selector");
                            timeSelectorRow.attr("data-time-value", timePresets[i].timeKey);
                            timeSelectorRow.html("<a>" + timePresets[i].timeKey + "</a>");
                            timeSelectorList.append(timeSelectorRow);
                        }
                        timeSelector.append(timeSelectorList);
                    }
                    else {
                        timeSelector.css("top", timeField.position().top + timeField.outerHeight(true) + 'px').css('left', timeField.position().left);
                        timeSelector.show();
                    }
                    timeField.after(timeSelector);
                    $(".time-selector .row").unbind("mousedown");
                    $(".time-selector .row").on("mousedown", function () {
                        timeField.val($(this).attr("data-time-value"));
                        timeSelector.hide();
                        timeField.change();
                    });
                });


                // Track the most recently clicked element, for the blur process
                var clickedElement = null;
                $(document).on("mousedown", function (e) {                    
                    clickedElement = $(e.target);
                });

                // When the time field blurs, hide the time selector, if it itself is not the target.
                $(dateTimeFields).on("blur", function (e) {                    
                    var timeSelector = $(".time-selector");
                    if (timeSelector.is(":visible") && !clickedElement.hasClass("time-selector") && !$.contains(timeSelector, clickedElement)) {
                        timeSelector.hide();
                    }
                    clickedElement = null;
                });

                // hide the time selector when clicked off.
                $("body").click(function (e) {
                    var target = $(e.target);                    
                    var timeSelector = $(".time-selector");
                    if (timeSelector.is(":visible") && !target.hasClass("time") && !$.contains(timeSelector, target)) {
                        timeSelector.hide();
                    }
                });
            }
        }
    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.DateTimeField.js